// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__3tXa7","title":"style_title__1-Q9_"};